export interface MenuCategory {
  id: string;
  name: string;
  items: MenuItem[];
}

export interface MenuItem {
  id: string;
  name: string;
  description: string;
  price: string;
  image?: string;
  badge?: string;
}

export const menuCategories: MenuCategory[] = [
  {
    id: 'chai',
    name: 'Traditional Chai',
    items: [
      {
        id: 'chai-1',
        name: 'Ghalib Special Karak Chai',
        description: 'Our signature blend of black tea brewed with cardamom, cinnamon, and fresh milk — the heart of our house.',
        price: '$3.50',
        badge: 'Best Seller',
      },
      {
        id: 'chai-2',
        name: 'Saffron Chai',
        description: 'Premium black tea infused with real Kashmiri saffron strands for a rich golden hue and aromatic flavor.',
        price: '$4.50',
      },
      {
        id: 'chai-3',
        name: 'Ginger Zing Chai',
        description: 'Bold and warming with fresh ginger root, black pepper, and cloves. Perfect for cold evenings.',
        price: '$3.75',
      },
      {
        id: 'chai-4',
        name: 'Masala Chai',
        description: 'Classic Indian spiced tea with a blend of cardamom, cloves, cinnamon, and black pepper.',
        price: '$3.50',
      },
    ],
  },
  {
    id: 'green-tea',
    name: 'Green Tea Bar',
    items: [
      {
        id: 'gt-1',
        name: 'Classic Green Tea',
        description: 'Pure, unflavored green tea leaves steeped to perfection. Clean, fresh, and calming.',
        price: '$3.00',
      },
      {
        id: 'gt-2',
        name: 'Jasmine Green Tea',
        description: 'Delicate green tea scented with fragrant jasmine blossoms. Floral, soothing, and light.',
        price: '$3.50',
      },
      {
        id: 'gt-3',
        name: 'Mint Green Tea',
        description: 'Refreshing green tea blended with fresh spearmint leaves. A revitalizing choice.',
        price: '$3.25',
      },
      {
        id: 'gt-4',
        name: 'Honey Lemon Green Tea',
        description: 'Green tea with a drizzle of natural honey and fresh lemon slice. Comfort in a cup.',
        price: '$3.75',
      },
    ],
  },
  {
    id: 'specialty',
    name: 'Specialty Teas',
    items: [
      {
        id: 'spec-1',
        name: 'Kashmiri Pink Tea',
        description: 'Traditional noon chai brewed with baking soda, salt, and milk, finished with crushed pistachios.',
        price: '$4.00',
        badge: 'Signature',
      },
      {
        id: 'spec-2',
        name: 'Turmeric Wellness Tea',
        description: 'Golden turmeric root with ginger, black pepper, and honey. A powerful wellness brew.',
        price: '$4.25',
      },
      {
        id: 'spec-3',
        name: 'Rose Cardamom Tea',
        description: 'Fragrant rose petals paired with green cardamom in a delicate, aromatic blend.',
        price: '$4.00',
      },
      {
        id: 'spec-4',
        name: 'Iced Peach Tea',
        description: 'Refreshing iced black tea with natural peach flavor. Served over crushed ice.',
        price: '$4.50',
      },
    ],
  },
  {
    id: 'snacks',
    name: 'Snacks & Sweets',
    items: [
      {
        id: 'snack-1',
        name: 'Fresh Paratha',
        description: 'Flaky, layered flatbread made fresh on our griddle. Served with a side of yogurt dip.',
        price: '$2.50',
      },
      {
        id: 'snack-2',
        name: 'Vegetable Samosa',
        description: 'Crispy golden pastry filled with spiced potatoes, peas, and herbs. Served with tamarind chutney.',
        price: '$2.00',
      },
      {
        id: 'snack-3',
        name: 'Chicken Samosa',
        description: 'Savory pastry pockets filled with seasoned minced chicken, onions, and fresh coriander.',
        price: '$2.75',
      },
      {
        id: 'snack-4',
        name: 'Baklava',
        description: 'Sweet, flaky pastry layered with chopped nuts and drizzled with honey syrup. A perfect tea companion.',
        price: '$3.50',
      },
      {
        id: 'snack-5',
        name: 'Kulfi Ice Cream',
        description: 'Traditional Indian ice cream made with thickened milk, cardamom, and pistachios.',
        price: '$3.00',
      },
    ],
  },
];